<template>
  <AuthLayout>
    <form @submit.prevent="onSubmit">
      <h2 class="intro-x font-bold text-2xl xl:text-3xl text-center xl:text-left">
        {{ $t('auth.login') }}
      </h2>
      <div class="intro-x mt-8">
        <InputString
          :placeholder="$t('auth.username')"
          v-model.trim="$v.form.username.$model"
          :vuelidate="$v.form.username"
          input-class="login__input input--lg"
        />

        <InputString
          type="password"
          :placeholder="$t('auth.password')"
          v-model.trim="$v.form.password.$model"
          :vuelidate="$v.form.password"
          input-class="login__input input--lg"
        />
      </div>
      <div class="intro-x flex text-gray-700 dark:text-gray-600 text-xs sm:text-sm mt-4">
        <div class="flex items-center mr-auto">
          <input id="remember-me" type="checkbox" class="input border mr-2" />
          <label class="cursor-pointer select-none" for="remember-me">{{
            $t('auth.rememberMe')
          }}</label>
        </div>
        <a>{{ $t('auth.forgotPassword') }}</a>
      </div>
      <div class="intro-x mt-5 xl:mt-8 text-center xl:text-left">
        <Button
          type="submit"
          class="button--lg w-full xl:w-32 text-white bg-theme-1 xl:mr-3 align-top"
          :loading="isLoading"
        >
          <span>{{ $t('auth.login') }}</span>
        </Button>
      </div>
    </form>
  </AuthLayout>
</template>

<script>
import { mapGetters } from 'vuex';
import { REDIRECT_URL_KEY } from '@/config';
import InputString from '@/components/ui/input/InputString';
import Button from '@/components/ui/button/Button';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { AUTH_REQUEST } from '@/store/actions/auth';
import AuthLayout from '@/views/auth/AuthLayout';

export default {
  components: { Button, InputString, AuthLayout },

  mixins: [validationMixin],

  validations: {
    form: {
      username: {
        required,
      },
      password: {
        required,
      },
    },
  },

  data() {
    return {
      loading: false,
      form: {
        username: '',
        password: '',
      },
      error: '',
    };
  },

  computed: {
    ...mapGetters(['authStatus']),
    isLoading() {
      return this.authStatus === 'loading';
    },
  },

  mounted() {
    document.querySelector('body').classList.add('login');
  },

  methods: {
    async onSubmit() {
      if (this.$v) {
        this.$v.form.$touch();
        if (this.$v.form.$anyError) {
          this.$toasted.show(this.$t('toast.failedForm'), { type: 'error' });
          return;
        }
      }

      try {
        await this.$store.dispatch(AUTH_REQUEST, this.form);
        if (this.$store.getters.isAuthenticated) {
          const redirectRoute = window.$cookies.get(REDIRECT_URL_KEY);
          this.$router.push(redirectRoute || { name: 'Home' });
          window.$cookies.remove(REDIRECT_URL_KEY);
        }
      } catch (error) {
        if (error.response.status === 422) {
          this.form = { username: '', password: '' };
          this.$v.$reset();
          this.$toasted.show(this.$t('toast.incorrectCredentials'), { type: 'error' });
        } else {
          this.$toasted.show(error.message, { type: 'error' });
        }
      }
    },
  },
};
</script>
